/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { FormattedMessage } from "react-intl";
import { ListView, WhiteSpace } from "antd-mobile";
import * as _ from "underscore";
import CategoryItem from "../CategoryItem";
import Color from "../../utils/Color";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 0;
`;

const StyledHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
`;

const StyledTitle = styled.span`
  color: black;
  font-size: 0.9em;
  font-weight: bold;
`;

const StyledClearBtn = styled.span`
  color: ${Color.highlightBlueTextColor};
  font-size: 0.8em;
  font-weight: bold;
  cursor: pointer;
`;

class CategoryBar extends Component {
  onEndReached = () => {
    const { onEndReached } = this.props;

    onEndReached && onEndReached();
  };

  render() {
    const {
      items,
      showClear,
      onItemClicked,
      onClearClicked,
      selectedItem
    } = this.props;
    const swipteSettings = {
      arrows: false,
      infinite: false,
      dots: true,
      swipeToSlide: false,
      swipe: true,
      speed: 300,
      rows: 1,
      slidesToShow: 7,
      slidesToScroll: 7,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 440,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 350,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 265,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ],
      afterChange: current => {
        if (current > _.size(items) - 10) {
          this.onEndReached();
        }
      }
    };
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });

    return (
      <StyledContainer>
        <StyledHeader>
          <StyledTitle>
            <FormattedMessage
              id="category.title"
              defaultMessage="Categories"
              description="Category Title"
            />
          </StyledTitle>
          {showClear ? (
            <StyledClearBtn
              className="opacity"
              onClick={() => onClearClicked && onClearClicked()}
            >
              <FormattedMessage
                id="app.clear"
                defaultMessage="Clear"
                description="Clear Title"
              />
            </StyledClearBtn>
          ) : null}
        </StyledHeader>
        <WhiteSpace size={"md"} />
        {/*<ListView*/}
        {/*className={"category-bar"}*/}
        {/*ref={el => (this.lv = el)}*/}
        {/*dataSource={dataSource.cloneWithRows(items)}*/}
        {/*renderRow={data => (*/}
        {/*<CategoryItem*/}
        {/*id={data.id}*/}
        {/*onItemClicked={onItemClicked}*/}
        {/*defaultImageSrc={*/}
        {/*data.image && data.image.default*/}
        {/*? data.image.default.src*/}
        {/*: "https://via.placeholder.com/150x150/808080"*/}
        {/*}*/}
        {/*activeImageSrc={*/}
        {/*data.image && data.image.active*/}
        {/*? data.image.active.src*/}
        {/*: "https://via.placeholder.com/150x150/F8B43E"*/}
        {/*}*/}
        {/*title={data.short_name}*/}
        {/*selected={*/}
        {/*_.find(selectedItem, function(id) {*/}
        {/*return id === data.id;*/}
        {/*}) !== undefined*/}
        {/*}*/}
        {/*/>*/}
        {/*)}*/}
        {/*pageSize={10}*/}
        {/*horizontal={true}*/}
        {/*scrollRenderAheadDistance={500}*/}
        {/*onEndReached={this.onEndReached}*/}
        {/*onEndReachedThreshold={500}*/}
        {/*style={{*/}
        {/*minHeight: "5.1em",*/}
        {/*width: "100%"*/}
        {/*}}*/}
        {/*/>*/}
        <div style={{ width: "100%", marginBottom: "5px" }}>
          <Slider {...swipteSettings}>
            {items.map(data => {
              return (
                <CategoryItem
                  key={data.id}
                  id={data.id}
                  onItemClicked={onItemClicked}
                  defaultImageSrc={
                    data.image && data.image.default
                      ? data.image.default.src
                      : "https://via.placeholder.com/150x150/808080"
                  }
                  activeImageSrc={
                    data.image && data.image.active
                      ? data.image.active.src
                      : "https://via.placeholder.com/150x150/F8B43E"
                  }
                  title={data.short_name}
                  selected={
                    _.find(selectedItem, function(id) {
                      return id === data.id;
                    }) !== undefined
                  }
                />
              );
            })}
          </Slider>
        </div>
      </StyledContainer>
    );
  }
}

CategoryBar.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  showClear: PropTypes.bool,
  selectedItem: PropTypes.array,
  onItemClicked: PropTypes.func,
  onClearClicked: PropTypes.func,
  onEndReached: PropTypes.func
};

CategoryBar.defaultProps = {
  showClear: false
};

export default CategoryBar;



// WEBPACK FOOTER //
// ./src/components/CategoryBar/index.js